import styled from 'styled-components';

const HeroWrapper = styled.div`
  height: 100%;
  @media (min-width: 768px) {
    height: calc(100vh - 53px);
  }
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 3rem 0;
`;

export { HeroWrapper };
